/**
 * @description 添加节流hooks
 * @author liushuai
 * @example
 * const OneSecondTimer = props => {
 *  const [seconds, setSeconds] = useState(0);
 *  useThrottle(() => {
 *    setSeconds(seconds + 1);
 *  }, 1000);
 *
 *  return <p>{seconds}</p>;
 *  };
 */
import { useEffect, useRef, useCallback } from 'react';

export const useThrottle = (callback: () => void, delay: number, dep = []) => {
    const { current } = useRef<{
        callback: () => void;
        timer: null | unknown;
    }>({ callback, timer: null });
    useEffect(() => {
        current.callback = callback;
    }, [callback]);
    return useCallback(() => {
        if (current.timer) {
            return;
        }
        current.timer = setTimeout(() => {
            delete current.timer;
        }, delay);
        current.callback();
    }, dep);
};
